import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { commonServices } from '../../../../api/services/commonServices';
import {
  setCalendarData,
  setDashboardCalendarLoader,
} from '../../../../infra/aggregates/dashboardCalendarSlice';

import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';

import AttendanceCalendarPresenterData from './AttendanceCalendarPresenterData';
import DTOAttendanceCalendarData from './DTOAttendanceCalendarData';

const AttendanceCalendarDataController = () => {
  const [leaveCalendar, setLeaveCalendar] = useState([]);

  const { t } = useTranslation();
  const selector = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const getDashboardCalendarData = (dashboard_calendar_data) => {
    setLeaveCalendar(dashboard_calendar_data);
  };

  const callbackSubmit = (month, year) => {
    dispatch(setDashboardCalendarLoader(true));

    const _currentMonth = month + 1;
    commonServices
      .getAttendanceCalendar(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        _currentMonth,
        year,
      )
      .then((response) => {
        if (
          response?.data?.leaves?.length > 0 ||
          response?.data?.absents?.length > 0 ||
          response?.data?.holidays?.length > 0 ||
          response?.data?.weekOffs?.length > 0
        ) {
          setLeaveCalendar(response?.data);
          dispatch(setDashboardCalendarLoader(false));
        } else {
          dispatch(setDashboardCalendarLoader(false));
          toast.error(t('No more Data!'));
        }
      })
      .catch(() => {
        dispatch(setDashboardCalendarLoader(false));
      });
  };

  return (
    <>
      <DTOAttendanceCalendarData
        setAllDashboardCalendarData={getDashboardCalendarData}
      />

      <AttendanceCalendarPresenterData
        leaveData={leaveCalendar}
        handleCalendarChange={callbackSubmit}
      />
    </>
  );
};

export default AttendanceCalendarDataController;
